import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/src/app/welcome/suppliers/page.tsx");
